<template>
	<div>
		<div class="row">
			<div class="col-md-4 ts-border ts-rounded-md">
				<div class="form-group">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.invoiceNo') }}</label>
					<input
						:value="record.wholesale_stock_out.invoice_no" 
						type="text" class="form-control" readonly>
				</div>
				<div class="form-group ts-mt-1">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.customer') }}</label>
					<input
						:value="record.wholesale_stock_out.customer.customer_name" 
						type="text" class="form-control" readonly>
				</div>
				<div class="form-group">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.grandTotal') }}</label>
					<input
						v-model="model.invoice_amount" 
						type="text" class="form-control" readonly>
				</div>
				<div class="form-group">
					<label class="ts-text-xs required">{{ $t('wholesaleReceipt.amountPaid') }}</label>
					<input
						v-model.number="model.amount_paid"
						@input="amountPaid" 
						type="text" class="form-control">
						<div class="validate" v-if="errors.has('amount_paid')">
              {{ errors.first('amount_paid') }}
            </div>
				</div>
				<div class="form-group">
					<label class="ts-text-xs required">{{ $t('wholesaleReceipt.amountDue') }}</label>
					<input
						v-model="model.amount_due" 
						type="text" class="form-control" readonly>
						            <div class="validate" v-if="errors.has('amount_due')">
              {{ errors.first('amount_due') }}
            </div>
				</div>
				<div class="form-group">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.fxRate') }}</label>
					<input
						v-model.number="model.fx_rate" 
						type="text" class="form-control" readonly>
				</div>
				<div class="form-group">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.nextPayment') }}</label>
					<a-date-picker
						v-model="model.next_payment_date"
						:disabled="!allowPick"
						format="DD-MM-YYYY" 
						valueFormat="DD-MM-YYYY" 
						class="ts-w-full"
					></a-date-picker>
					<div class="validate" v-if="errors.has('next_payment_date')">
              {{ errors.first('next_payment_date') }}
          </div>
				</div>
				<div class="form-group">
					<label class="ts-text-xs">{{ $t('wholesaleReceipt.remark') }}</label>
					<textarea
						v-model.trim="model.remark" 
						rows="3" class="form-control"></textarea>
				</div>
				<div class="form-group ts-text-right ts-space-x-2">
					<ts-button @click.prevent="$emit('cancel')">{{ $t('cancel') }}</ts-button>
					<ts-button color="primary" 
						:waiting="waiting"
						@click.prevent="onSave"
					>{{ $t('save') }}</ts-button>
				</div>
			</div>
			<div class="col-md-8">
				<ts-preview-pdf v-model="waiting" :src="src" ></ts-preview-pdf>
			</div>
		</div>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation'

export default {
	name:'paymentReceipt',
	props: ['record'],
	data(){
		return {
			waiting: false,
			model: {
				stock_out_id: '',
				invoice_amount: '',
				amount_paid: '',
				amount_due: 0,
				fx_rate: '',
				next_payment_date: '',
				remark: '',
			},
			src: null,
			errors: new Errors(),
		}
	},
	computed: {
		allowPick() {
      return this.model.amount_due > 0
    },
	},
	created(){
		this.setData()
	},
	methods: {
		setData(){
			this.model.stock_out_id = this.record.stock_out_id
			this.model.fx_rate = parseFloat(this.$store.state.authUser.sys_setting.fx_rate)
			this.model.invoice_amount = this.record.amount_due
		},
		amountPaid(){
			this.model.next_payment_date = null
			this.model.amount_due = _.round(this.model.invoice_amount - this.model.amount_paid, 2)
		},
		onSave(){
			this.waiting = true
			this.src = null
			this.$store.dispatch('wholesale/receipt/store', this.model)
			.then(response => {
				this.src = response.url
			})
			.catch(error => {
				this.$toasted.error(error.message)
				this.errors = new Errors(error.errors)
				this.show_pdf = false
			})
			.finally(() => {
				this.waiting = false
			})
		}
	}
}
</script>